import { inject, Injectable } from '@angular/core';
import { ODataEntities, ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import { Observable } from 'rxjs';
import { CustomerOrganisation } from '@workspace-app/odatabackend/QualicoatBackendModel';

@Injectable({
  providedIn: 'root',
})
export class CustomerDataService {
  private factory = inject(ODataServiceFactory);

  organisationService: ODataEntitySetService<CustomerOrganisation>;
  
  constructor() {
    this.organisationService = this.factory.entitySet<CustomerOrganisation>(
      'CustomerOrganisations',
      'QualicoatBackend.Domain.Crm.OrganisationTypes.CustomerOrganisation'
    );
  }

  public searchByName(searchString: string): Observable<ODataEntities<CustomerOrganisation>> {
    return this.organisationService.entities()
      ?.query((q) => {
        const filter = [`contains(tolower(name),tolower('${searchString}'))`];
        q.filter(filter.join(' and '));
      })
      .fetch();
  }
}
